"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _union2 = _interopRequireDefault(require("lodash/union"));
var _difference2 = _interopRequireDefault(require("lodash/difference"));
var _intersection2 = _interopRequireDefault(require("lodash/intersection"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _checkboxChecked = _interopRequireDefault(require("cccisd-icons/svg/checkbox-checked2"));
var _checkboxUnchecked = _interopRequireDefault(require("cccisd-icons/svg/checkbox-unchecked2"));
var _checkboxPartial = _interopRequireDefault(require("cccisd-icons/svg/checkbox-partial2"));
var _cross = _interopRequireDefault(require("cccisd-icons/svg/cross4"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right20"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down20"));
var _warning = _interopRequireDefault(require("cccisd-icons/warning2"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var MultiCheckbox = function MultiCheckbox(props) {
  var options = props.options,
    field = props.field,
    form = props.form,
    label = props.label,
    warningOptions = props.warningOptions,
    warningMessage = props.warningMessage;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    search = _useState4[0],
    setSearch = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showSelected = _useState6[0],
    setShowSelected = _useState6[1];
  (0, _react.useEffect)(function () {
    if (field.value === 'all') {
      return;
    }
    var optionValues = options.map(function (option) {
      return option.value;
    });
    form.setFieldValue(field.name, (0, _intersection2["default"])(field.value, optionValues));
  }, [options]);
  var filteredOptions = (0, _react.useMemo)(function () {
    var lowerSearch = search.toLowerCase();
    return options.filter(function (item) {
      if (search && !item.label.toLowerCase().includes(lowerSearch)) {
        return false;
      }
      if (showSelected && field.value !== 'all' && !field.value.includes(item.value)) {
        return false;
      }
      return true;
    });
  }, [options, search, field.value, showSelected]);
  (0, _react.useEffect)(function () {
    if (field.value === 'all') {
      return;
    }
    if (field.value.length === options.length) {
      form.setFieldValue(field.name, 'all');
    }
  }, [field.value, options]);
  var toggleAll = function toggleAll() {
    if (field.value === 'all') {
      form.setFieldValue(field.name, []);
    } else {
      form.setFieldValue(field.name, 'all');
    }
  };
  var selectAll = function selectAll() {
    if (field.value === 'all') {
      return;
    }
    var newValue = (0, _union2["default"])(field.value, filteredOptions.map(function (item) {
      return item.value;
    }));
    form.setFieldValue(field.name, newValue);
  };
  var selectNone = function selectNone() {
    var newValue;
    if (field.value === 'all') {
      newValue = (0, _difference2["default"])(options.map(function (item) {
        return item.value;
      }), filteredOptions.map(function (item) {
        return item.value;
      }));
    } else {
      newValue = (0, _difference2["default"])(field.value, filteredOptions.map(function (item) {
        return item.value;
      }));
    }
    form.setFieldValue(field.name, newValue);
  };
  var count = /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].count
  }, "(", field.value === 'all' ? options.length : field.value.length, "/", options.length, ")");
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].group
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].check,
    onClick: function onClick() {
      return toggleAll();
    }
  }, function () {
    if (field.value === 'all') {
      return /*#__PURE__*/_react["default"].createElement(_checkboxChecked["default"], null);
    }
    if (Array.isArray(field.value) && field.value.length > 0) {
      return /*#__PURE__*/_react["default"].createElement(_checkboxPartial["default"], null);
    }
    return /*#__PURE__*/_react["default"].createElement(_checkboxUnchecked["default"], null);
  }()), /*#__PURE__*/_react["default"].createElement("label", {
    onClick: function onClick() {
      return setExpanded(!expanded);
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].expandIcon
  }, expanded ? /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null) : /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], null)), label), count), expanded && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].listWrapper
  }, options.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].buttonArea
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].searchArea
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "text",
    className: (0, _classnames2["default"])('form-control form-control-sm', _defineProperty({}, _style["default"].filled, Boolean(search))),
    value: search,
    onChange: function onChange(e) {
      return setSearch(e.target.value);
    },
    placeholder: "Search..."
  }), search ? /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].clear,
    onClick: function onClick() {
      return setSearch('');
    }
  }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)) : null), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-secondary btn-sm",
    onClick: selectAll
  }, "Select all"), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-secondary btn-sm",
    onClick: selectNone
  }, "Select none"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-check ms-2"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-check-label"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: "form-check-input",
    type: "checkbox",
    checked: showSelected,
    onChange: function onChange() {
      return setShowSelected(!showSelected);
    }
  }), ' ', "show selected only"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].list
  }, filteredOptions.length === 0 && 'No values', filteredOptions.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: option.value,
      className: "form-check"
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-check-label"
    }, /*#__PURE__*/_react["default"].createElement("input", {
      className: "form-check-input",
      type: "checkbox",
      onChange: function onChange() {
        var currentValue = field.value === 'all' ? options.map(function (item) {
          return item.value;
        }) : field.value;
        form.setFieldValue(field.name, (0, _xor2["default"])(currentValue, [option.value]));
      },
      checked: field.value === 'all' || field.value.includes(option.value)
    }), ' ', option.label, warningOptions && warningOptions.includes(option.value) && /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: warningMessage
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "text-warning"
    }, /*#__PURE__*/_react["default"].createElement(_warning["default"], {
      spaceLeft: true
    })))));
  }))));
};
MultiCheckbox.propTypes = {
  field: _propTypes["default"].object,
  form: _propTypes["default"].object,
  label: _propTypes["default"].node,
  options: _propTypes["default"].array,
  warningOptions: _propTypes["default"].array,
  warningMessage: _propTypes["default"].node
};
var _default = exports["default"] = MultiCheckbox;